<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M154.896 237.254H138.336C138.272 237.254 138.227 237.19 138.246 237.133C138.668 235.878 138.789 234.483 138.444 233.018C137.634 229.51 134.359 227.13 130.771 227.13C117.211 227.13 71.2715 227.13 71.2715 227.13C68.5391 227.13 66.1515 228.582 64.8172 230.758C63.7766 232.467 61.9253 233.51 59.9271 233.51H55.0816C50.7149 233.51 47.4782 236.301 47.2547 239.994C47.0121 244.006 50.185 247.334 54.1367 247.334H84.8184C86.4464 247.334 88.0551 247.91 89.2107 249.062C90.4555 250.304 92.1728 251.078 94.0689 251.078H154.89C158.695 251.078 161.784 247.987 161.784 244.166C161.784 240.352 158.701 237.254 154.89 237.254H154.896Z"
      class="fill-brand-300"
    />
    <path
      d="M110.214 225.856H95.3455C93.5156 225.856 92.0322 227.343 92.0322 229.178V236.685C92.0322 238.519 93.5156 240.006 95.3455 240.006H110.214C112.044 240.006 113.527 238.519 113.527 236.685V229.178C113.527 227.343 112.044 225.856 110.214 225.856Z"
      class="fill-brand-500"
    />
    <path
      d="M187.78 225.434H172.911C171.082 225.434 169.598 226.921 169.598 228.755V236.262C169.598 238.097 171.082 239.584 172.911 239.584H187.78C189.61 239.584 191.093 238.097 191.093 236.262V228.755C191.093 226.921 189.61 225.434 187.78 225.434Z"
      class="fill-brand-500"
    />
    <path
      d="M186.261 5.12H96.8715C84.7674 5.12 74.9551 14.9568 74.9551 27.0912V208.947C74.9551 221.082 84.7674 230.918 96.8715 230.918H186.261C198.365 230.918 208.177 221.082 208.177 208.947V27.0912C208.177 14.9568 198.365 5.12 186.261 5.12Z"
      class="fill-brand-100"
    />
    <path
      d="M141.56 44.9344C147.003 44.9344 151.417 40.5103 151.417 35.0528C151.417 29.5953 147.003 25.1712 141.56 25.1712C136.116 25.1712 131.703 29.5953 131.703 35.0528C131.703 40.5103 136.116 44.9344 141.56 44.9344Z"
      class="fill-secondary-500"
    />
    <path
      d="M92.7472 105.939H88.1826C86.8111 105.939 85.6992 107.054 85.6992 108.429V144.736C85.6992 146.111 86.8111 147.226 88.1826 147.226H92.7472C94.1187 147.226 95.2306 146.111 95.2306 144.736V108.429C95.2306 107.054 94.1187 105.939 92.7472 105.939Z"
      class="fill-brand-500"
    />
    <path
      d="M92.7472 33.1712H88.1826C86.8111 33.1712 85.6992 34.2858 85.6992 35.6608V71.968C85.6992 73.343 86.8111 74.4576 88.1826 74.4576H92.7472C94.1187 74.4576 95.2306 73.343 95.2306 71.968V35.6608C95.2306 34.2858 94.1187 33.1712 92.7472 33.1712Z"
      class="fill-brand-500"
    />
    <path
      d="M129.736 87.0656C128.67 86.9312 127.611 86.8096 126.538 86.688C124.444 86.8864 122.357 87.1296 120.282 87.4624C115.928 88.1536 111.574 88.9152 107.201 89.4144C107.188 89.4144 107.182 89.4272 107.182 89.44V103.424C107.182 107.507 110.131 111.123 114.172 111.597C115.583 111.763 116.93 111.552 118.124 111.059C119.477 110.502 120.952 111.539 120.952 113.005V117.011C120.952 121.408 124.38 125.184 128.766 125.254C133.152 125.325 136.829 121.734 136.829 117.299V112.576C136.829 108.979 137.914 107.782 141.228 106.598C144.433 105.453 146.871 103.034 146.871 99.4176V88.8576C146.871 88.8576 146.858 88.832 146.852 88.832C141.151 88.5888 135.463 87.776 129.743 87.0592L129.736 87.0656Z"
      class="fill-brand-300"
    />
    <path
      d="M208.177 84.5696H74.9551V95.9104H208.177V84.5696Z"
      class="fill-secondary-500"
    />
    <path
      d="M89.6895 200.032H193.436V202.803C193.436 207.533 189.606 211.373 184.888 211.373H98.2377C93.5199 211.373 89.6895 207.533 89.6895 202.803V200.032Z"
      class="fill-secondary-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'AccidentFridge'
  }
</script>
